import map from "lodash/map"
import { COLORS } from "constants-lib/colors"
import { makeStyles } from "tss-react/mui"
import { Tile } from "./components/Tile/Tile"

const useStyles = makeStyles()((theme, { displayVerticalLines }) => ({
  root: {
    padding: `0 15px`,
    [theme.breakpoints.up(`md`)]: {
      padding: 0,
    },
  },
  tileContainer: {
    display: `flex`,
    flexWrap: `wrap`,
    [theme.breakpoints.up(`md`)]: {
      marginLeft: -15,
      marginRigiht: -15,
    },
  },
  tile: {
    padding: `1.5rem`,
    [theme.breakpoints.up(`lg`)]: {
      padding: `0 18px`,
    },
    [theme.breakpoints.up(`md`)]: {
      padding: `0 10px`,
    },
  },
  tileLeft: {
    [theme.breakpoints.up(`md`)]: {
      borderRight: displayVerticalLines
        ? `1px solid ${theme.palette.border.divider}`
        : `none`,
      width: `34%`,
    },
  },
  tileMiddle: {
    [theme.breakpoints.up(`md`)]: {
      borderRight: displayVerticalLines
        ? `1px solid ${theme.palette.border.divider}`
        : `none`,
      width: `34%`,
    },
  },
  tileRight: {
    [theme.breakpoints.up(`md`)]: {
      width: `32%`,
    },
  },
}))

/**
  Value Proposition Design Specifications

  Desktop:

  https://wm.invisionapp.com/share/NMV7K2HUY8C#/screens/397216375

  Tablet:

  https://wm.invisionapp.com/share/REVCGOXQUC6#/screens/398601555

  Mobile:

  https://wm.invisionapp.com/share/SFV9FL9ZXQJ#/screens/397753383
* */

export const ValueProposition = ({
  componentBackgroundColor = COLORS.WHITE,
  propositions = [],
  displayVerticalLines = true,
}) => {
  const { classes } = useStyles({
    displayVerticalLines,
  })

  const renderTileRow = () => {
    const hasGreenBackground = componentBackgroundColor === COLORS.GREEN

    return (
      <div className={classes.tileContainer} data-testid="TileContainer">
        {map(
          propositions,
          (
            {
              icon,
              heading,
              headingAlignment,
              description,
              descriptionAlignment,
            },
            i,
          ) => (
            <div
              key={i}
              className={`${classes.tile} ${
                i === 0
                  ? classes.tileLeft
                  : i === 1
                  ? classes.tileMiddle
                  : classes.tileRight
              }`}
            >
              <Tile
                key={`${heading}${i}`}
                icon={icon}
                heading={heading}
                headingAlignment={headingAlignment}
                description={description}
                descriptionAlignment={descriptionAlignment}
                hasGreenBackground={hasGreenBackground}
              />
            </div>
          ),
        )}
      </div>
    )
  }
  return (
    <div
      className={`ValueProposition container ${classes.root}`}
      data-testid="ValueProposition"
    >
      {renderTileRow()}
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// ValueProposition.propTypes = {
//   componentBackgroundColor: PropTypes.string,
//   propositions: PropTypes.arrayOf(
//     PropTypes.shape({
//       icon: PropTypes.string,
//       heading: PropTypes.string,
//       description: PropTypes.string,
//     }),
//   ),
//   displayVerticalLines: PropTypes.bool,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// ValueProposition.defaultProps = {
//   componentBackgroundColor: COLORS.WHITE,
//   propositions: [],
//   displayVerticalLines: true,
// }

export default ValueProposition
